import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {success} from "../../utils/Tostify";

const initialState = {
  companyName: "",
  website: "",
  email: "",
  trademark: "",
  trademarkName: "",
  usptoLink: "",
  address: "",
  state: "",
  city: "",
  zip: "",
};

const ContactUsTwo = ({ isOpen, onClose }) => {
  const [form, setForm] = useState(initialState);

  useEffect(() => {
    if (!isOpen) {
      setForm(initialState);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = () => {
    const requiredFields = ["companyName", "website", "email", "address", "state", "city", "zip"];
    if (form.trademark === "Yes") {
      requiredFields.push("trademarkName", "usptoLink");
    }

    for (const field of requiredFields) {
      if (!form[field]) {
        alert(`Please fill in the ${field.replace(/([A-Z])/g, ' $1')} field.`);
        return;
      }
    }

      success("Successful");
    onClose(); // Close modal after submission
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Contact Us</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              Company Name<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="companyName"
              placeholder="Enter Company Name"
              value={form.companyName}
              onChange={handleChange}
              autoFocus
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Website URL<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="website"
                  placeholder="Enter Website URL"
                  value={form.website}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Email<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter Email (.edu)"
                  value={form.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>
              Trademark?<span className="text-danger">*</span>
            </Form.Label>
            <div>
              <Form.Check
                inline
                label="Yes"
                type="radio"
                name="trademark"
                value="Yes"
                checked={form.trademark === "Yes"}
                onChange={handleChange}
              />
              <Form.Check
                inline
                label="No"
                type="radio"
                name="trademark"
                value="No"
                checked={form.trademark === "No"}
                onChange={handleChange}
              />
            </div>
          </Form.Group>

          {form.trademark === "Yes" && (
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Trademark Name<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="trademarkName"
                    placeholder="Enter Trademark Name"
                    value={form.trademarkName}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    USPTO Link<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="usptoLink"
                    placeholder="Enter USPTO Link"
                    value={form.usptoLink}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Street Address<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="address"
              placeholder="Enter Address"
              value={form.address}
              onChange={handleChange}
            />
          </Form.Group>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  State<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="state"
                  placeholder="Enter State"
                  value={form.state}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  City<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  value={form.city}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  ZIP Code<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="zip"
                  placeholder="Enter ZIP Code"
                  value={form.zip}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactUsTwo;
